var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M634.796-415.385q-37.104 0-63.258-25.972-26.154-25.973-26.154-63.077 0-37.105 25.973-63.259 25.973-26.153 63.077-26.153 37.105 0 63.259 25.972 26.153 25.973 26.153 63.078 0 37.104-25.973 63.258-25.972 26.153-63.077 26.153ZM425.384-206.154v-45.231q0-13.06 6.539-24.876 6.538-11.816 17.615-18.97 41.923-23.923 87.97-36.654 46.046-12.73 97.107-12.73 51.062 0 97.108 12.73 46.046 12.731 87.969 36.654 11.077 7.154 17.616 18.97 6.538 11.816 6.538 24.876v45.231H425.384Zm41.385-52.307v12.307h335.692v-12.307q-39.615-22.308-82.076-34.231-42.462-11.923-85.77-11.923-43.307 0-85.769 11.923-42.461 11.923-82.077 34.231Zm167.846-196.924q20.077 0 34.654-14.577 14.577-14.577 14.577-34.653 0-20.077-14.577-34.654-14.577-14.577-34.654-14.577-20.076 0-34.653 14.577-14.577 14.577-14.577 34.654 0 20.076 14.577 34.653 14.577 14.577 34.653 14.577Zm0-49.23Zm0 258.461ZM155.384-420v-40h280.001v40H155.384Zm0-320v-40h440.001v40H155.384Zm312.462 160H155.384v-40h335.385q-7.077 9.308-12.885 18.923-5.807 9.616-10.038 21.077Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserList);
export default __webpack_public_path__ + "static/media/userList.1b951bde1edeb682d8319951e0d0978c.svg";
export { ForwardRef as ReactComponent };